import React from "react";
import { Container, Carousel } from "react-bootstrap";
import "./References.css";

// Dynamischer Import aller Bilder aus Before & After
const importAll = (r) => r.keys().map(r);
const beforeImages = importAll(require.context("../../assets2/references/before", false, /\.(png|jpe?g|webp)$/));
const afterImages = importAll(require.context("../../assets2/references/after", false, /\.(png|jpe?g|webp)$/));

const references = beforeImages.map((before, index) => ({
  before,
  after: afterImages[index] || before, // Falls kein After-Bild existiert, wird das Vorher-Bild genommen
  title: `Projekt ${index + 1}`,
}));

const References = () => {
  return (
    <Container className="references-section">
      <h2 className="text-center">Unsere Referenzen</h2>
      <p className="text-center">Hier sind einige unserer erfolgreich abgeschlossenen Projekte.</p>
      
      <Carousel>
        {references.map((ref, index) => (
          <Carousel.Item key={index}>
            <div className="carousel-container">
              <div className="carousel-image">
                <img src={ref.before} alt="Vorher" />
                <p>Vorher</p>
              </div>
              <div className="carousel-image">
                <img src={ref.after} alt="Nachher" />
                <p>Nachher</p>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </Container>
  );
};

export default References;
